import { render } from "./EditWorkerForm.vue?vue&type=template&id=8bc6ec76&ts=true"
import script from "./EditWorkerForm.vue?vue&type=script&lang=ts"
export * from "./EditWorkerForm.vue?vue&type=script&lang=ts"

import "./EditWorkerForm.vue?vue&type=style&index=0&id=8bc6ec76&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__